import { Path } from './path';

export class Breadcrumbps {
  constructor(
    public current?: string,
    public path?: Path,
  ) { }
}
